import React, { useState } from 'react';
import { Table } from 'antd';
import { Button } from 'components/ui';
import { useDeleteBulkThrottleExemptions } from 'mutation/mail';
import { useGetThrottleExemptionList } from 'query/mail';
import { filter, includes } from 'lodash';
import useCheckPermissions from 'hooks/auth/useCheckPermission';

const ExemptionList = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const { userCheckPermission } = useCheckPermissions();
  const { data, isFetching } = useGetThrottleExemptionList();
  const {
    mutateAsync: deleteBulkThrottleExemptions,
    isLoading: isDeleting,
  } = useDeleteBulkThrottleExemptions({
    onSuccess: () => handleSelectionChange([]),
  });

  const hasSelected = selectedRows.length > 0;

  const handleSelectionChange = selected => {
    const selectedExemptions = filter(data, item =>
      includes(selected, item.id),
    );
    setSelectedRows(selectedExemptions.map(v => v.id));
  };

  const canDelete = userCheckPermission('user.view');

  return (
    <div>
      <div style={{ margin: 10 }}>
        {canDelete && hasSelected && !isFetching && (
          <Button
            className="users__delete-password-btn"
            loading={isDeleting}
            type="primary"
            onClick={() => deleteBulkThrottleExemptions(selectedRows)}
          >
            Delete ({selectedRows.length})
          </Button>
        )}
      </div>
      <Table
        columns={[
          {
            title: 'Exempted Emails',
            dataIndex: 'email',
            key: 'email',
          },
        ]}
        dataSource={data}
        loading={isFetching}
        pagination={{
          pageSize: 15,
        }}
        rowKey="id"
        rowSelection={
          canDelete
            ? {
                selectedRowsKeys: selectedRows,
                onChange: handleSelectionChange,
              }
            : null
        }
        size="small"
      />
    </div>
  );
};

export default ExemptionList;
